import { apiMerchant, apiBank } from "./config";

export const createPixAndGoTransaction = (merchantSlug, payload) =>
  apiBank
    .post(`/banks/pix-and-go`, { ...payload, merchant_slug: merchantSlug })
    .then((res) => res.data);

export const getPixAndGoStatus = (uuid) =>
  apiMerchant
    .get(`/merchant/pix-and-go/${uuid}/status`)
    .then((res) => res.data);

export const getPixAndGoConfig = (merchantSlug) =>
  apiMerchant
    .post(`/merchant/pix-and-go/config`, { merchant_slug: merchantSlug })
    .then((res) => res.data);

export const completePixAndGo = (uuid, payload) =>
  apiMerchant
    .post(`/merchant/pix-and-go/${uuid}/complete`, payload)
    .then((res) => res.data);
